import { DOCUMENT_CONTENT_CONTROL } from '@Constants/types';

/* contentControl Object
    -> Text
        -> original : Original text the Highlight call is called with.
            - Could be > 255 characters,
            - Could have special characters
        -> modified : Text modified to do searching.
            - max characters : 255,
            - Replaced spaces with ?
            - Replaced special characters with ?

    -> controlTitle : String displayed inside contentControl
    -> controlTag : String used to retrieve the contentControl in the future
        - controlTag here acts as unique index to grab any entry in array
    -> location : Key that specifies which scorecard analytic or metadata value it is.
        -> type : "scorecard" / "metadata"
        -> name : name associated with the value
        -> index : name + key
    -> status : Pending/Complete/Failed.
    -> color : The color of Highlight.
    -> results : object of type Range.Collection contains results of search.
    -> hitsCount : Number of text occurances found in document.
*/

const initialState = {
    readyToSearch: true,
    currentContentObj: {},
    contentObjArr: []
};

const updateArr = (arr, index, newObj) => {
    arr[index] = newObj;
};

const getControlObj = (contentObjArr, controlTag) => {
    const index = contentObjArr.map(obj => obj.controlTag).indexOf(controlTag);
    return contentObjArr[index];
};

const pushOrUpdateArr = (contentObjArr, newContentObj) => {
    const oldIndex = contentObjArr.map(obj => obj.controlTag).indexOf(newContentObj.controlTag);

    if (oldIndex === -1) contentObjArr.push(newContentObj);
    else updateArr(contentObjArr, oldIndex, newContentObj);
    return contentObjArr;
};

export default function contentControlReducer(state = initialState, action) {
    switch (action.type) {
        /*
            payload :
                -> originalText
                -> modifiedText
                -> textLocation
                -> HighlightColor
        */
        case DOCUMENT_CONTENT_CONTROL.CREATE_REQUEST:
            return {
                ...state,
                readyToSearch: false,
                currentContentObj: {
                    status: 'pending',
                    text: action.payload.text,
                    location: action.payload.textLocation,
                    color: action.payload.contentControlOptions.color,
                    controlTitle: action.payload.contentControlOptions.title
                }
            };
        /*
            payload:
                -> searchResults
                -> controlTag
        */
        case DOCUMENT_CONTENT_CONTROL.CREATE_SUCCESS:
            return {
                ...state,
                readyToSearch: true,
                contentObjArr: pushOrUpdateArr(state.contentObjArr, {
                    ...state.currentContentObj,
                    searchResults: action.payload.searchResults,
                    controlTag: action.payload.controlTag,
                    hitsCount: action.payload.searchResults.items.length,
                    status: 'complete'
                })
            };
        case DOCUMENT_CONTENT_CONTROL.CREATE_FAILURE:
            return {
                ...state,
                readyToSearch: true,
                contentObjArr: pushOrUpdateArr(state.contentObjArr, {
                    ...state.currentContentObj,
                    status: 'failed'
                })
            };
        /*
            payload:
                -> controlTag
        */
        case DOCUMENT_CONTENT_CONTROL.DELETE_REQUEST:
            return {
                ...state,
                contentObjArr: pushOrUpdateArr(state.contentObjArr, {
                    ...getControlObj(action.payload),
                    status: 'deleted'
                })
            };
        default:
            return state;
    }
}
